module.exports = __webpack_public_path__ + "static/img/person-checkmark-icon-login-to-web-portal-healthtrackrx-university-2023-150x150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person-checkmark-icon-login-to-web-portal-healthtrackrx-university-2023-150x150.png
// module id = sHhy
// module chunks = 0